module.exports = __webpack_public_path__ + "img/doc.7d80e98.svg";